// components/ShopPage.jsx
import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import config from '../config/config';
import { useParams, Link } from 'react-router-dom';
//import { useInfiniteQuery } from '@tanstack/react-query';
//import { fetchProducts } from '../libs/apis/ProductsApi';
import {
  SlidersHorizontal,
  Grid3x3,
  List,
  ChevronDown,
  X,
  Star,
  Minus,
  Plus,
  Heart,
  ShoppingBag,
  ShoppingCart,
  ChevronRight,
  ChevronLeft,
} from 'lucide-react';

import FlashBar from "../components/FlashBar";
import ShareableNav from "../components/ShareableNav";
import NavigationBar from "../components/NavigationBar";
import CategoriesNav from "../components/CategoriesNav";
import FooterSection from "../components/FooterSection";
import CartSection from "../components/CartSection";
import SearchWidget from "../components/SearchWidget";
import { useCart } from '../context/CartContext';
const CACHE_KEY_LAYOUT = 'layout_settings_cache_shops';
const CACHE_KEY_PRODUCTS = 'products_cache_shops_v6'; // new key for products
const CACHE_TTL = 6*1; // 1.5 minutes

 
const ShopPage = () => {
  const token = localStorage.getItem('token');
   let featuredBg = localStorage.getItem('featuredBg') || '#2563eb';
  const activeBg = localStorage.getItem('activeBg') || '#2563eb';
if(featuredBg=='bg-gray-400'){
  featuredBg='#2563eb';
}
  const { _slug,_status } = useParams('all');
  const navigate = useNavigate();
  const [isCurrentProductId, setCurrentId] = useState(null);
  const loaderRef = useRef(null);
   const [__status, setStatus] = useState(_status || null);

   const {
    addToCart,
    changeQuantity,
    isInCart,
    getQuantity,
  } = useCart();



  const [isOpen, setIsOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [activeDesign, setActiveDesign] = useState('design1');
  const [viewMode, setViewMode] = useState('grid');
  const [showMobileFilters, setShowMobileFilters] = useState(false);
 const[categoryId,setCatId]=useState('all');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedSort, setSelectedSort] = useState('featured');
  const [priceRange, setPriceRange] = useState([0, 500]);
  const [selectedSizes, setSelectedSizes] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [productLinkPattern, setPattern] = useState();

  // Products + pagination state
  const [products, setProducts] = useState([]); // will be accumulated
  //const [categoryId, setCatId] = useState('all');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(null);

  const availableSizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
  const availableColors = ['Black', 'White', 'Blue', 'Red', 'Green', 'Beige'];

  // Layout configs
  const [flashConfig, setFlashConfig] = useState(null);
  const [navConfig, setNavConfig] = useState(null);
  const [searchConfig, setSearchConfig] = useState(null);
  const [catNavConfig, setcatNavConfig] = useState(null);
  const [cartConfig, setCartConfig] = useState(null);
  const [footerConfig, setFooterConfig] = useState(null);

  const [categories, setCategories] = useState(['All']);
  const [pendingUpdates, setPendingUpdates] = useState({});

  // ────────────────────────────────────────────────
  // Cache Helpers
  // ────────────────────────────────────────────────
  const getCached = (key) => {
    const item = localStorage.getItem(key);
    if (!item) return null;
    try {
      const { data, ts } = JSON.parse(item);
      if (Date.now() - ts < CACHE_TTL) return data;
      localStorage.removeItem(key);
      return null;
    } catch {
      localStorage.removeItem(key);
      return null;
    }
  };

  const setCached = (key, data) => {
    localStorage.setItem(key, JSON.stringify({ data, ts: Date.now() }));
  };



  // ────────────────────────────────────────────────
  // Load Products → Cache FIRST + Append on Pagination
  // ────────────────────────────────────────────────
  const fetchProducts = useCallback(async (pageNum = 1, catId = 'all',option='') => {
    const cacheKey = `${CACHE_KEY_PRODUCTS}_${catId}`;

    // 1. Try cache first for this category + page
    const cachedPage = getCached(cacheKey);
    if (cachedPage && pageNum === cachedPage.page) {
      if (pageNum === 1) {
        setProducts(cachedPage.products || []);
      } else {
        setProducts(prev => [...prev, ...(cachedPage.products || [])]);
      }
      setTotalPages(cachedPage.totalPages || 1);
      setHasMore(pageNum < cachedPage.totalPages);
      setLoading(false);
      return;
    }

    setLoading(pageNum === 1);
    setLoadingMore(pageNum > 1);
    setError(null);

    try {
      
      if(option!=''){

      const response = await axios.get(`${config.API_URL}/api/pullProducts/${catId}/${__status}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        params: { page: pageNum, limit: 22 },
      });


       const newProducts = response.data.data || [];
      const meta = response.data.meta || {};

      // Append or replace depending on page
      if (pageNum === 1) {
        setProducts(newProducts);
      } else {
        setProducts(prev => [...prev, ...newProducts]);
      }

      setTotalPages(meta.last_page || 1);
      setHasMore(pageNum < meta.last_page);

      // Cache this page's result
      setCached(cacheKey, {
        page: pageNum,
        products: newProducts,
        totalPages: meta.last_page || 1
      });
    }else{
       const response = await axios.get(`${config.API_URL}/api/pullProducts/${catId}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        params: { page: pageNum, limit: 12 },
      });

        const newProducts = response.data.data || [];
      const meta = response.data.meta || {};

      // Append or replace depending on page
      if (pageNum === 1) {
        setProducts(newProducts);
      } else {
        setProducts(prev => [...prev, ...newProducts]);
      }

      setTotalPages(meta.last_page || 1);
      setHasMore(pageNum < meta.last_page);

      // Cache this page's result
      setCached(cacheKey, {
        page: pageNum,
        products: newProducts,
        totalPages: meta.last_page || 1
      });
    }

     

    } catch (err) {
     // console.error("Products fetch failed:", err);
      setError("Could not load products");
      toast.error("Could not load products");
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  }, []);



/**const {
  data,
  isLoading,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
} = useInfiniteQuery({
  queryKey: ['products', { categoryId, __status }],
  queryFn: fetchProducts,

  getNextPageParam: (lastPage) => {
    if (lastPage.current_page < lastPage.total_pages) {
      return lastPage.current_page + 1;
    }
    return undefined;
  },
});**/


//const products = data?.pages?.flatMap(page => page?.products) || [];









 




 /**const loadMore = useCallback(() => {
    if (!hasMore || loading || loadingMore) return;
    setPage(prev => prev + 1);
  }, [hasMore, loading, loadingMore]);

 /** useEffect(() => {
    
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMore();
        }
      },
      {
        root: null,
        rootMargin: '1000px',   // load earlier (good UX)
        threshold: 0.1
      }
    );

    const currentLoader = loaderRef.current;
    if (currentLoader) {
      observer.observe(currentLoader);
    }

    return () => {
      if (currentLoader) {
        observer.unobserve(currentLoader);
      }
    };
  }, [loadMore]);

  useEffect(() => {
  let observer: IntersectionObserver;

  const updateObserver = () => {
    // Cleanup previous observer if exists
    if (observer) observer.disconnect();

    const preloadDistance = Math.max(600, window.innerHeight * 1.5); // at least 800px, or 1.5x screen height

    observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMore();
        }
      },
      {
        root: null,
        rootMargin: `0px 0px ${preloadDistance}px 0px`,
        threshold: 0.1,
      }
    );

    const currentLoader = loaderRef.current;
    if (currentLoader) {
      observer.observe(currentLoader);
    }
  };

  updateObserver();

  // Recreate on resize (handles orientation change, window resize, etc.)
  window.addEventListener('resize', updateObserver);

  return () => {
    window.removeEventListener('resize', updateObserver);
    if (observer) observer.disconnect();
  };
}, [loadMore]);**/

 const loadMore = useCallback(() => {
  if (!hasMore || loading || loadingMore) return;
  setLoadingMore(true);
  setPage(prev => prev + 1);
}, [hasMore, loading, loadingMore]);

setInterval(function(){
  const scrollTop =
    window.scrollY ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0;

    const scrollBottom =
    window.scrollY ||
    document.documentElement.scrollBottom ||
    document.body.scrollBottom ||
    0;

  const viewportHeight = window.innerHeight;

  const documentHeight =document.body.scrollHeight

  const scrollableHeight = documentHeight - scrollTop;

  let percentPage = 0;

if (scrollableHeight > 0) {
  percentPage = (scrollableHeight/documentHeight) * 100;
}
if(percentPage.toFixed(2)<40 && !hasMore){

  loadMore();
}
  /**console.log(
    "Page scroll:", percentPage.toFixed(2) + "%",
    "scrollTop:", scrollTop,
    'scrollBottom',scrollBottom,
    "docHeight:", documentHeight,
    "viewport:", viewportHeight,
    "scrollable:", scrollableHeight,
    console.log("doc:", document.documentElement.scrollHeight),

console.log("body:", document.body.scrollHeight),
console.log("viewport:", window.innerHeight),
  );**/
},5000);




/**useEffect(() => {

  const loader = loaderRef.current;
  if (!loader) return;

  let observer: IntersectionObserver | null = null;

  const setupObserver = () => {
    if (observer) observer.disconnect();
     
    const viewportHeight = window.innerHeight;

    // Trigger when loader is in the last 30% of the viewport
    // This means user has scrolled ~70% of the visible screen toward the bottom
    const triggerDistance = Math.floor(viewportHeight * 0.25);   // 30% of viewport
//console.log('window view port',viewportHeight, " triggerDistance ",triggerDistance);
    observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          //console.log("Called triggerDistance ",triggerDistance);
          loadMore();
        }
      },
      {
        root: null,
        rootMargin: `0px 0px ${triggerDistance}px 0px`,
        threshold: 0,
      }
    );

    observer.observe(loader);
  };

  // Initial setup
  setupObserver();

  // Update on resize / orientation change (debounced)
  let timeout: NodeJS.Timeout;
  const handleResize = () => {
    clearTimeout(timeout);
    timeout = setInterval(setupObserver, 100);
  };

  window.addEventListener('resize', handleResize);
  window.addEventListener('orientationchange', handleResize);

  return () => {
    clearTimeout(timeout);
    window.removeEventListener('resize', handleResize);
    window.removeEventListener('orientationchange', handleResize);
    if (observer) observer.disconnect();
  };
}, [loadMore]);**/






  useEffect(() => {
    if (page > 1) {
      fetchProducts(page, categoryId,_status);
    }
  }, [page, categoryId, fetchProducts]);

  // ────────────────────────────────────────────────
  // Rest of your logic (cart, filters, etc.) remains unchanged
  // ────────────────────────────────────────────────

  const formatCurrency = (amount) =>
    new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);

  const fetchAllProductsAndCategories = async () => {
    try {
      const [categoriesRes] = await Promise.all([
        axios.get(`${config.API_URL}/api/pullCategories`, {
          headers: { Authorization: `Bearer ${token}` },
        })
      ]);

      const categoriesArray =
        categoriesRes.data?.newCategories2 ||
        categoriesRes.data?.data ||
        [];
      setCategories(['All', ...categoriesArray]);
    } catch (err) {
      console.error("Failed to fetch categories:", err);
    }
  };

  useEffect(() => {
    fetchAllProductsAndCategories();
  }, [token]);

  /**const pullCartItems = useCallback(async () => {
    if (!token) return;
    try {
      const response = await axios.get(`${config.API_URL}/api/pullCartItems`, {
        headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
        withCredentials: true,
      });
      setCartItems(response.data.cartItems || []);
    } catch (err) {
      console.error('Failed to load cart:', err);
    }
  }, [token]);

  useEffect(() => {
    if (isOpen) pullCartItems();
  }, [isOpen, pullCartItems]);**/

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };









  const sendQuantityUpdate = useCallback(
    debounce(async (itemId, newQty, productId) => {
      try {
        await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, { withCredentials: true });
        const xsrfToken = document.cookie
          .split('; ')
          .find(row => row.startsWith('XSRF-TOKEN='))
          ?.split('=')[1];

        await axios.post(
          `${config.API_URL}/api/addToCart2/${productId}`,
          {
            cart_item_id: itemId,
            product_id: productId,
            quantity: newQty,
            session: localStorage.getItem('session_id') || `guest-${Date.now()}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
              "X-XSRF-TOKEN": decodeURIComponent(xsrfToken || ''),
            },
            withCredentials: true,
          }
        );
      } catch (err) {
        console.error('Failed to update quantity:', err);
        toast.error('Failed to update quantity');
      } finally {
        setPendingUpdates(prev => {
          const { [itemId]: _, ...rest } = prev;
          return rest;
        });
      }
    }, 700),
    []
  );



  const setCategoryId = (id) => {
    setCatId(id);
    setPage(1);
   setProducts([]); // reset products when category changes
    setHasMore(true);
    fetchProducts(1, id,'category_search');
  };

   useEffect(() => {
    if(_status=='undefined'){
      setStatus('all');
      setCatId('all');
      setCategoryId('all');
    }else{
      setStatus(_status);
    }
  }, []);

  const toggleSize = (size) => {
    setSelectedSizes(prev =>
      prev.includes(size) ? prev.filter(s => s !== size) : [...prev, size]
    );
  };

  const toggleColor = (color) => {
    setSelectedColors(prev =>
      prev.includes(color) ? prev.filter(c => c !== color) : [...prev, color]
    );
  };

  const handleAddToCart = (id) => {
    setCurrentId(id);
  };

  const toggleWishlist = (id) => {
    setWishlist(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
  };

  const getProductUrl = (product) => {
    navigate('/products/'+product.id);
    return;
    if (product.customUrl) return product.customUrl;
    if (!productLinkPattern) return '#';
    return productLinkPattern
      .replace('{id}', product.id)
      .replace('{slug}', product.slug || product.name.toLowerCase().replace(/\s+/g, '-'))
      .replace('{name}', encodeURIComponent(product.name));
  };

  const clearFilters = () => {
    setSelectedCategory('all');
    setSelectedSizes([]);
    setSelectedColors([]);
    setPriceRange([0, 500]);
  };

//console.log(products);

  const filteredProducts = useMemo(() => {
    let result = products.filter(p => {
     // if (selectedCategory !== 'all' && p.category?.toLowerCase() !== selectedCategory.toLowerCase()) return false;
     // if (selectedSizes.length > 0 && !p.sizes?.some(s => selectedSizes.includes(s))) return false;
     // if (selectedColors.length > 0 && !p.colors?.some(c => selectedColors.includes(c))) return false;
      if (p.price < priceRange[0] || p.price > priceRange[1]) return false;
      return true;
    });

    if (selectedSort === 'price-low') result.sort((a, b) => a.price - b.price);
    if (selectedSort === 'price-high') result.sort((a, b) => b.price - a.price);
    if (selectedSort === 'newest') result.sort((a, b) => b.id - a.id);
    if (selectedSort === 'rating') result.sort((a, b) => (b.rating || 0) - (a.rating || 0));

    return result;
  }, [products, selectedCategory, selectedSizes, selectedColors, priceRange, selectedSort]);




useEffect(() => {
  if(_slug.trim().toLowerCase()=='all'){
     setSelectedCategory('all'); 
    setCategoryId('all');
    setPage(1);
  }else{
     setSelectedCategory(_slug); 
    setCategoryId(_slug);
    setPage(1);
  }
 
},[_slug]);



// Load initial page (1) or cached version
  /**useEffect(() => {
    fetchProducts(1, categoryId,_status);
  }, [categoryId]);**/
   const ProductCard = ({ product, isList = false }) => {
    const qty = getQuantity(product.id);
    const inCart = isInCart(product.id);
     return (
    <a
      key={product.id}
      onClick={()=>getProductUrl(product)}
      className="group bg-white cursor-pointer border border-gray-200 rounded-xl overflow-hidden transition-all hover:shadow-xl flex flex-col"
    >
      <div className="relative w-full overflow-hidden flex-shrink-0" style={{ aspectRatio: '4/5' }}>
        <img
          src={product.image_url || 'https://admins.junisaproducts.com/assets/images/icons/snacks.svg'}
          alt={product.name}
          className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
          onError={(e) => { e.target.src = "https://admins.junisaproducts.com/assets/images/icons/snacks.svg"; }}
        />
      </div>

      <div className="p-4 flex flex-col flex-grow">
        <h1 className="text-md font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-gray-700 transition-colors">
          {product.name}
        </h1>

        <div className="flex items-center gap-2 mb-4 mt-auto">
          <span className="text-lg font-bold text-gray-900">{formatCurrency(product.display_price || product.price)}</span>
          {product.regular_price && product.regular_price > product.price && (
            <span className="text-sm text-gray-500 line-through">{formatCurrency(product.regular_price)}</span>
          )}
        </div>



         {!inCart ? (
                      <button
                         disabled={product.qty <= 0}
                        onClick={(e) => {
                          e.stopPropagation();
                          addToCart(product, 1);
                        }}
                        className={`w-full ${featuredBg} text-white rounded-lg flex items-center justify-between px-4 py-2.5 shadow-lg`}
                        style={{ background: featuredBg }}
                      >
                        <ShoppingCart className="w-4 h-4" />
                        {product.qty > 0 ? 'Add to Cart' : 'Out of Stock'}
                      </button>
                    ) : (
                      <div
                        className={`w-full ${activeBg} text-white rounded-lg flex items-center justify-between px-4 py-2.5 shadow-lg`}
                        style={{ background: activeBg }}
                      >
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            changeQuantity(product.id, -1);
                          }}
                          disabled={qty <= 1}
                          className="disabled:opacity-40 p-1"
                        >
                          <Minus className="w-4 h-4" />
                        </button>
                        <span className="font-bold text-base">{qty}</span>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            changeQuantity(product.id, 1);
                          }}
                          className="p-1"
                        >
                          <Plus className="w-4 h-4" />
                        </button>
                      </div>
                    )}




     
      </div>
    </a>
   );
  };

  // Design 1 – Sidebar Filters
  const Design1 = () => (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12 md:mt-[-70px]">
       {/* <div className="mb-10">
          <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2">Shop All</h1>
          <p className="text-gray-600">Find what you're looking for</p>
        </div>*/}

        <div className=" mt-[-30px] md:mt-0 flex flex-col lg:flex-row gap-8">
          <button
            onClick={() => setShowMobileFilters(true)}
            className="lg:hidden w-full flex items-center justify-center gap-2 bg-white border border-gray-300 py-3 px-4 rounded-xl font-medium hover:bg-gray-50 mb-6"
          >
            <SlidersHorizontal size={20} /> Filters & Sort
          </button>

          <aside className="hidden lg:block w-72 xl:w-80 flex-shrink-0">
            <div className="bg-white rounded-2xl shadow-sm p-6 sticky top-8">
              <h2 className="text-xl font-semibold mb-6">Filters</h2>

              <div className="mb-8 pb-6 border-b border-gray-200">
                <h3 className="text-sm font-semibold uppercase tracking-wide mb-4">Category</h3>
                <div className="space-y-2">
                  {categories.map(cat => (
                    <button
                      key={cat}
                      onClick={() => { setSelectedCategory(cat.toLowerCase()); setCategoryId(cat.toLowerCase()); }}
                      className={`w-full text-left py-2 px-3 rounded-lg text-sm transition ${
                        selectedCategory === cat.toLowerCase() ? 'bg-gray-900 text-white font-medium' : 'hover:bg-gray-50'
                      }`}
                    >
                      {cat}
                    </button>
                  ))}
                </div>
              </div>

              <div className="mb-8 pb-6 border-b border-gray-200">
                <h3 className="text-sm font-semibold uppercase tracking-wide mb-4">Price</h3>
                <input
                  type="range"
                  min="0"
                  max="500"
                  value={priceRange[1]}
                  onChange={e => setPriceRange([0, Number(e.target.value)])}
                  className="w-full accent-black"
                />
                <div className="flex justify-between text-sm text-gray-700 mt-3">
                  <span>{formatCurrency(priceRange[0])}</span>
                  <span>{formatCurrency(priceRange[1])}</span>
                </div>
              </div>
            </div>
          </aside>

          <div className="flex-1">
  {/* Header Bar - sticky-ish feel on mobile, clean separation */}
  <div className="sticky top-[-35px] md:top-0 z-10 bg-white/80 backdrop-blur-md border-b border-gray-100 -mx-5 px-5 py-4 mb-6 md:-mx-0 md:px-0 md:py-5 md:mb-8">
    <div className="flex flex-row  sm:flex-row sm:items-center sm:justify-between gap-4">
      {/* Left side - count + optional filter count */}
      <div className="flex items-center gap-3">
        <p className="text-gray-700">
          Showing <span className="font-semibold text-gray-900">{filteredProducts.length}</span> products
        </p>
        {/* Optional: active filters count badge */}
        {/* {activeFiltersCount > 0 && (
          <span className="text-xs font-medium px-2.5 py-1 bg-gray-100 rounded-full">
            {activeFiltersCount} filters
          </span>
        )} */}
      </div>

      {/* Right side - sort + view toggle */}
      <div className="flex items-center gap-3 sm:gap-4">
        {/* Sort Dropdown - modern look */}
        <div className="relative inline-block">
          <select
            value={selectedSort}
            onChange={(e) => setSelectedSort(e.target.value)}
            className={`
              appearance-none bg-white border border-gray-200 rounded-xl 
              px-4 py-2.5 pr-10 text-sm font-medium text-gray-900
              focus:outline-none focus:ring-2 focus:ring-black/30 focus:border-black/30
              cursor-pointer transition-all hover:border-gray-300
            `}
          >
            <option value="featured">Featured</option>
            <option value="price-low">Price: Low to High</option>
            <option value="price-high">Price: High to Low</option>
            <option value="newest">Newest Arrivals</option>
            <option value="rating">Top Rated</option>
            {/* Optional: <option value="bestselling">Best Selling</option> */}
          </select>

          {/* Custom arrow */}
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-500">
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>

        {/* Optional: Grid / List toggle */}
        {/* <div className="flex border border-gray-200 rounded-lg overflow-hidden">
          <button
            onClick={() => setViewMode('grid')}
            className={`p-2 ${viewMode === 'grid' ? 'bg-gray-100' : 'bg-white hover:bg-gray-50'}`}
          >
            <Grid size={20} />
          </button>
          <button
            onClick={() => setViewMode('list')}
            className={`p-2 ${viewMode === 'list' ? 'bg-gray-100' : 'bg-white hover:bg-gray-50'}`}
          >
            <List size={20} />
          </button>
        </div> */}
      </div>
    </div>
  </div>

  {/* Products Grid */}
 <div className="grid gap-5 sm:gap-6 grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
  {loading ? (
    // ─── SKELETON LOADING STATE ────────────────────────────────────────
    Array.from({ length: 10 }).map((_, index) => (
      <div
        key={`skeleton-${index}`}
        className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 animate-pulse"
      >
        {/* Image placeholder */}
        <div className="aspect-[3/4] w-full bg-gradient-to-br from-gray-100 to-gray-200">
         
        </div>

        <div className="p-4 space-y-3">
          {/* Category / Brand line */}
          <div className="h-4 w-20 bg-gray-200 rounded"></div>

          {/* Product name - two lines for realism */}
          <div className="space-y-2">
            <div className="h-5 w-5/6 bg-gray-200 rounded"></div>
            <div className="h-5 w-3/4 bg-gray-200 rounded"></div>
          </div>

          {/* Price area */}
          <div className="flex items-center gap-2">
            <div className="h-6 w-24 bg-gray-200 rounded"></div>
            <div className="h-5 w-16 bg-gray-300 rounded"></div>
          </div>

          {/* Rating stars placeholder */}
          <div className="flex items-center gap-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="h-4 w-4 bg-gray-200 rounded-full"></div>
            ))}
            <div className="h-4 w-12 bg-gray-200 rounded ml-1.5"></div>
          </div>

          {/* Button area */}
          <div className="h-10 w-full bg-gray-200 rounded-xl mt-3"></div>
        </div>
      </div>
    ))
  ) : filteredProducts.length === 0 ? (
    // ─── SKELETON LOADING STATE ────────────────────────────────────────
    Array.from({ length: 10 }).map((_, index) => (
      <div
        key={`skeleton-${index}`}
        className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 animate-pulse"
      >
        {/* Image placeholder */}
        <div className="aspect-[3/4] w-full bg-gradient-to-br from-gray-100 to-gray-200"></div>

        <div className="p-4 space-y-3">
          {/* Category / Brand line */}
          <div className="h-4 w-20 bg-gray-200 rounded"></div>

          {/* Product name - two lines for realism */}
          <div className="space-y-2">
            <div className="h-5 w-5/6 bg-gray-200 rounded"></div>
            <div className="h-5 w-3/4 bg-gray-200 rounded"></div>
          </div>

          {/* Price area */}
          <div className="flex items-center gap-2">
            <div className="h-6 w-24 bg-gray-200 rounded"></div>
            <div className="h-5 w-16 bg-gray-300 rounded"></div>
          </div>

          {/* Rating stars placeholder */}
          <div className="flex items-center gap-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="h-4 w-4 bg-gray-200 rounded-full"></div>
            ))}
            <div className="h-4 w-12 bg-gray-200 rounded ml-1.5"></div>
          </div>

          {/* Button area */}
          <div className="h-10 w-full bg-gray-200 rounded-xl mt-3"></div>
        </div>
      </div>
    ))
  ) : (
    // ─── REAL PRODUCTS ──────────────────────────────────────────────────
    filteredProducts.map((product, index) => (
      <ProductCard
        key={product.id}
        product={product}
        // Helpful optional props:
        priority={index < 8}           // better LCP for first products
        // layout={viewMode}           // if you add grid/list toggle
      />
    ))
  )}
</div>

  <div ref={loaderRef} className="py-10 flex justify-center" style={{
      height: '150px',           // important – give it real height
      margin: '40px 0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
    
    {loadingMore ? (
      <div className="flex items-center gap-3 text-gray-500">
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-gray-400 border-t-black"></div>
        <span className="text-sm">Loading more products...</span>
      </div>
    ) : filteredProducts.length > 0 && !hasMore ? (
      <p className="text-sm text-gray-500">You've reached the end</p>
    ) : null}
  </div>

  {/* Optional classic pagination (uncomment if you prefer it over infinite scroll) */}
  {/* {totalPages > 1 && (
    <div className="flex justify-center items-center gap-4 mt-10">
      <button
        onClick={() => setPage(p => Math.max(p - 1, 1))}
        disabled={page === 1 || loading}
        className="px-5 py-2.5 rounded-lg border border-gray-300 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-50 transition"
      >
        Previous
      </button>
      
      <span className="font-medium text-gray-800">
        Page {page} of {totalPages}
      </span>
      
      <button
        onClick={() => setPage(p => Math.min(p + 1, totalPages))}
        disabled={page >= totalPages || loading}
        className="px-5 py-2.5 rounded-lg border border-gray-300 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-50 transition"
      >
        Next
      </button>
    </div>
  )} */}
</div>
        </div>

        {showMobileFilters && (
          <div className="fixed inset-0 bg-black/60 z-50 lg:hidden">
            <div className="absolute right-0 top-0 bottom-0 w-5/6 max-w-md bg-white overflow-y-auto">
              <div className="p-6">
                <div className="flex items-center justify-between mb-8">
                  <h2 className="text-2xl font-bold">Filters</h2>
                  <button onClick={() => setShowMobileFilters(false)}>
                    <X size={32} />
                  </button>
                </div>

                <div className="mb-8">
                  <h3 className="text-sm font-semibold uppercase mb-4">Category</h3>
                  <div className="space-y-2">
                    {categories.map(cat => (
                      <button
                        key={cat}
                        onClick={() => { setSelectedCategory(cat.toLowerCase()); setCategoryId(cat.toLowerCase()); }}
                        className={`w-full text-left py-3 px-4 rounded-xl text-sm ${
                          selectedCategory === cat.toLowerCase() ? 'bg-gray-900 text-white' : 'hover:bg-gray-100'
                        }`}
                      >
                        {cat}
                      </button>
                    ))}
                  </div>
                </div>

                <button
                  onClick={() => setShowMobileFilters(false)}
                  className="w-full bg-black text-white py-4 rounded-xl font-semibold mt-6"
                >
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div className="flex flex-col min-h-screen">
    <style>{`
       @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800;900&family=Quicksand:wght@400;500;600;700&display=swap');
     html,body{
      font-family: ${config.FONT_FAMILY}, sans-serif !important;
     }
      `}
      </style>
     <ShareableNav/>

      <main className="flex-grow">
      <br/><br/><br/><br/>
        {activeDesign === 'design1' ? <Design1 /> : null}
      </main>

      {footerConfig && <FooterSection config={footerConfig} />}
    </div>
  );
};

export default ShopPage;